export const footerData = [
  { label: 'about', value: '' },
  { label: 'link', value: '' },
  { label: 'copyright', value: '' },
  { label: 'legalNotices', value: '' },
  { label: 'terms', value: '' },
  { label: 'privacy', value: '' },
  { label: 'navigation', value: '' }
]

export default {}
